<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>

    <!-- 关键词检索  -->
    <div
      class="width100 f14 backwhite border-rd3 flex-betweennowrap"
      style="min-height: 85px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="60px"
        class="demo-ruleForm flexleft"
      >
        <el-form-item label="姓名">
          <el-input
            class="width100"
            v-model="input"
            placeholder="  请输入姓名查询"
          />
        </el-form-item>
        <div class="margin-left20">
          <el-button type="primary" class="searchbut" @click="submitForm()"
            >检 索</el-button
          >
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </div>
      </el-form>
      <div class="margin-top10 margin-bot10 pad-right20">
        <span class="attention margin-right10" @click="permission()"
          >网盘权限</span
        >
        <span class="attention" @click="Addpeople()">新 增</span>
      </div>
    </div>
    <el-skeleton
      class="width100 backwhite margin-top15 pad-top20 border-rd3 alldigital"
      style="min-height: 70vh"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div class="width100 margin-auto backwhite pad-bot20">
          <div class="width100 margin-auto pad-bot10">
            <el-table
              :data="page"
              stripe
              class="eltable width98 margin-auto f14"
            >
              <el-table-column
                label="姓名"
                align="left"
                v-if="columns[0].visible"
              >
                <template slot-scope="scope"
                  >{{ scope.row.user.realname }} ({{
                    scope.row.user.mobile
                  }})</template
                ></el-table-column
              >
              <el-table-column
                label="角色"
                align="center"
                v-if="columns[1].visible"
                ><template slot-scope="scope">{{
                  scope.row.authority
                }}</template></el-table-column
              >
              <el-table-column
                label="工作单位"
                align="center"
                width="300"
                v-if="columns[2].visible"
                ><template slot-scope="scope">{{
                  scope.row.company
                }}</template></el-table-column
              >
              <el-table-column
                label="部门"
                align="center"
                v-if="columns[3].visible"
                ><template slot-scope="scope"
                  >{{ scope.row.department }}
                  <span
                    style="color: red"
                    v-if="scope.row.dep != null && scope.row.dep.dev == 1"
                    >[研]</span
                  >
                  <span
                    style="color: red"
                    v-if="scope.row.dep != null && scope.row.dep.finance == 1"
                    >[财]</span
                  >
                </template></el-table-column
              >
              <el-table-column
                label="学历"
                align="center"
                v-if="columns[4].visible"
                ><template slot-scope="scope">{{
                  scope.row.qualification
                }}</template></el-table-column
              >
              <el-table-column
                label="职称"
                align="center"
                v-if="columns[5].visible"
                ><template slot-scope="scope">{{
                  scope.row.rank
                }}</template></el-table-column
              >
              <el-table-column
                label="月薪（元）"
                align="center"
                v-if="columns[6].visible"
                ><template slot-scope="scope">
                  <el-input
                    class="nullinput"
                    v-model="scope.row.wage"
                    @blur="roleblur(scope.row, $event)"
                  ></el-input> </template
              ></el-table-column>
              <el-table-column
                label="管理"
                align="center"
                width="320"
                class-name="small-padding fixed-width"
                v-if="columns[7].visible"
              >
                <template slot-scope="scope">
                  <div class="flex cursorpointer">
                    <span style="color: #52c5cb" @click="changerole(scope.row)"
                      >切换角色</span
                    >
                    <span
                      class="pad-left10"
                      style="color: #52c5cb"
                      @click="Unbind(scope.row)"
                      >取消绑定</span
                    >
                    <span
                      class="pad-left10"
                      style="color: #52c5cb"
                      @click="Personal(scope.row)"
                      >个人资料</span
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </template>
    </el-skeleton>

    <!-- 权限 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblepermis"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
      class="dialogheader"
    >
      <Networkpermission></Networkpermission>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleaddpeople"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
      class="dialogheader"
    >
      <Addpeople></Addpeople>
    </el-dialog>
    <!-- 个人资料 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblePersonal"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class=""
    >
      <p class="textalign-left f16 dimensional">员工编辑</p>
      <el-form
        ref="form"
        :model="form"
        label-width="0"
        class="width96 margin-auto flex-betweenwrap margin-top20 f14"
      >
        <el-form-item label="" class="width45">
          <p>部门选择</p>
          <el-select
            placeholder="请选择部门"
            v-model="form.dep_id"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in optiondep_id"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>员工薪资(元/月)</p>
          <el-input placeholder="10000" v-model="form.wage"></el-input>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>员工性别</p>
          <el-select
            placeholder="请选择性别"
            v-model="form.sex"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>出生年月</p>
          <el-date-picker
            style="width: 100%"
            v-model="form.birthday"
            type="date"
            placeholder="请选择出生年月"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>最高学历</p>
          <el-select
            placeholder="  请选择最高学历
"
            v-model="form.qualification"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              class="width100"
              v-for="item in optionsxl"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option
          ></el-select>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>所学专业</p>
          <el-input
            placeholder="请输入所学专业"
            v-model="form.major"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>评定职称</p>
          <el-input placeholder="请选择职称" v-model="form.rank"></el-input>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>入职时间</p>
          <el-date-picker
            style="width: 100%"
            v-model="form.entry"
            type="date"
            placeholder="请选择入职时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" class="width45">
          <p>离职时间</p>
          <el-date-picker
            style="width: 100%"
            v-model="form.departure"
            type="date"
            placeholder="请选择离职时间"
            value-format="yyyy-MM-dd"
            :editable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p>所属企业</p>
          <el-input
            placeholder="外部人员请输入所属单位"
            v-model="form.company"
          ></el-input>
        </el-form-item>
        <el-form-item label="" class="width100">
          <p>备注信息</p>
          <el-input
            placeholder="备注信息"
            type="textarea"
            :autosize="autosize"
            v-model="form.remark"
          ></el-input>
        </el-form-item>

        <div class="width100 margin-top20 textalign-right">
          <el-button @click="dialogVisiblePersonal = false">取 消</el-button
          ><el-button type="primary" @click="onSubmit()">确 定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
<script>
import {
  bindstafflist,
  bindremove,
  bindchangerole,
  bindeditstaff,
  eosindex,
} from "@/api/loader/loder.api";
import switchcore from "@/components/switchcore.vue";
import callback from "@/components/callback.vue";
import Networkpermission from "../My-business/Network-permission.vue";
import Addpeople from "../My-business/Add-people.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisiblePersonal: false,
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      page: [],
      form: {
        name: "",
        wage: "", //薪资
        sex: "", //性别
        company: "", //所属单位
        birthday: "", //出生日期
        rank: "", //职称
        major: "", //专业
        qualification: "", //学历
        remark: "", //备注
        authority: "",
        dep_id: "",
        departure: "",
        entry: "",
      },
      // depment: "", //所在部门
      options: [
        {
          value: "男",
          label: "男",
        },
        {
          value: "女",
          label: "女",
        },
      ],
      optionsxl: [
        {
          value: "小学",
          label: "小学",
        },
        {
          value: "初中",
          label: "初中",
        },
        {
          value: "高中",
          label: "高中",
        },
        {
          value: "专科教育",
          label: "专科教育",
        },
        {
          value: "本科教育",
          label: "本科教育",
        },
        {
          value: "研究生及以上",
          label: "研究生及以上",
        },
      ],
      optiondep_id: [],
      rowid: "",
      titel: "",
      serchkey: true,
      input: "",
      dialogVisiblepermis: false,
      dialogVisibleaddpeople: false,
      columns: [
        { key: 0, label: `姓名`, visible: true },
        { key: 1, label: `角色`, visible: true },
        { key: 2, label: `工作单位`, visible: true },
        { key: 3, label: `部门`, visible: true },
        { key: 4, label: `学历`, visible: true },
        { key: 5, label: `职称`, visible: true },
        { key: 6, label: `月薪`, visible: true },
        { key: 7, label: `管理`, visible: true },
      ],
    };
  },
  components: {
    Networkpermission,
    Addpeople,
    callback,
    switchcore,
  },
  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    roleblur(row, $event) {
      bindeditstaff({
        id: row.id, // 员工列表主键id
        wage: $event.target.value, //薪资
        sex: row.sex, //性别
        company: row.company, //所属单位
        birthday: row.birthday, //出生日期
        // department: this.depment, //所在部门
        rank: row.rank, //职称
        major: row.major, //专业
        qualification: row.qualification, //学历
        remark: row.remark, //备注
        dep_id: row.dep_id,
        entry: row.entry,
        departure: row.departure,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisiblePersonal = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    onSubmit() {
      bindeditstaff({
        id: this.rowid, // 员工列表主键id
        wage: this.form.wage, //薪资
        sex: this.form.sex, //性别
        company: this.form.company, //所属单位
        birthday: this.form.birthday, //出生日期
        // department: this.depment, //所在部门
        rank: this.form.rank, //职称
        major: this.form.major, //专业
        qualification: this.form.qualification, //学历
        remark: this.form.remark, //备注
        dep_id: this.form.dep_id,
        entry: this.form.entry,
        departure: this.form.departure,
      }).then((res) => {
        if (res.data.code == 200) {
          this.refresh();
          this.dialogVisiblePersonal = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置
    resetForm() {
      this.input = null;
      bindstafflist({
        all: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data;
          this.page.forEach((i) => {
            if (i.authority == 0) {
              i.authority = "企业负责人";
            }
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "普通人员";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // 取消绑定
    Unbind(row) {
      this.$confirm("此操作将删除此成员, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          bindremove({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 切换角色
    changerole(row) {
      bindchangerole({ id: row.id }).then((res) => {
        if (res.data.code == 200 && res.data.data == "切换成功") {
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    //网盘权限
    permission() {
      this.dialogVisiblepermis = true;
    },
    // 个人资料
    Personal(row) {
      this.dialogVisiblePersonal = true;
      this.rowid = row.id;
      this.form.authority = row.authority; // 员工列表主键id
      this.form.wage = row.wage; //薪资
      this.form.sex = row.sex; //性别
      this.form.company = row.company; //所属单位
      this.form.birthday = row.birthday; //出生日期
      // this.depment = row.department; //所在部门
      this.form.rank = row.rank; //职称
      this.form.major = row.major; //专业
      this.form.qualification = row.qualification; //学历
      this.form.remark = row.remark; //备注

      if (row.dep_id == 0) {
        this.form.dep_id = "";
      } else {
        this.form.dep_id = row.dep_id;
      }
      this.form.entry = row.entry;
      this.form.departure = row.departure;
    },
    submitForm() {
      if (this.input != "") {
        bindstafflist({
          _keywords: this.input,
          all: 1,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data;
            this.page.forEach((i) => {
              if (i.authority == 0) {
                i.authority = "企业负责人";
              }
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "普通人员";
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 添加人员
    Addpeople() {
      this.dialogVisibleaddpeople = true;
    },
    refresh() {
      bindstafflist({
        all: 1,
        _keywords: this.input,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data;
          this.page.forEach((i) => {
            if (i.authority == 0) {
              i.authority = "企业负责人";
            }
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "普通人员";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });
    this.titel = window.sessionStorage.getItem("businesscompany");
    bindstafflist({
      all: 1,
    }).then((res) => {
      if (res.data.code == 200) {
        this.page = res.data.data;
        this.page.forEach((i) => {
          if (i.authority == 0) {
            i.authority = "企业负责人";
          }
          if (i.authority == 1) {
            i.authority = "管理员";
          }
          if (i.authority == 2) {
            i.authority = "普通人员";
          }
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    /** 查询部门列表 */

    eosindex({}).then((res) => {
      if (res.data.code == 200) {
        this.optiondep_id = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("addpeople", (data) => {
      if (data == "yes") {
        this.dialogVisibleaddpeople = false;
        this.dialogVisiblepermis = false;
        this.refresh();
      } else {
        this.dialogVisibleaddpeople = false;
        this.dialogVisiblepermis = false;
      }
    });
  },
};
</script>
<style scoped>
.nullinput >>> .el-input__inner {
  border: none;
  /* height: 38px; */
  color: #7b83ea;
  text-align: right;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
}
.dialogheader >>> .el-dialog__header {
  padding: 0;
}
.dialogheader >>> .el-dialog__body {
  padding: 0 30px;
}
.Tablecont {
  border-bottom: 1px solid #efefef;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.progress {
  height: 10px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>